import api from '@/api/apifolder/index'
import store from '@/store';
import WaterMark from '@zonst/watermark';
// import menuOperated from '@/util/menuBtnAuth';
import StatesData from '@/components/common/js/StatesData'

let userInfoGlobal = null // 全局, 用户信息
// let permissionObjGlobal = null // 全局, 用户权限信息

const curDate = new Date()
const formatMonth = curDate.getMonth() + 1 >= 10 ? curDate.getMonth() + 1 : `0${(curDate.getMonth() + 1)}`
const dateFormat = `${curDate.getFullYear()}${formatMonth}${curDate.getDate()}`

// 获取用户信息
export const getUserInfo = async () => {
  await api.getUserName().then((res) => {
    if (res && res.data && Number(res.data.errno) === 0) {
      // console.log('获取的用户信息 new', res);
      userInfoGlobal = res.data.user_info
      // 在某个地方初始化（通常是你通过接口拿到用户信息以后）
      WaterMark.init({
        text: `${userInfoGlobal.zonst_user_id}${userInfoGlobal.user_name}${dateFormat}`,
        fontSize: 24,
        secret: true,
      })
      window.localStorage.setItem('user_info_new', JSON.stringify(res.data.user_info))
    }
  }).catch((err) => {
    console.log('获取用户信息错误!', err);
  })
}

// 获取用户权限
export const getUserPer = async () => {
  await getUserInfo()
  // console.log('userInfoGlobal', userInfoGlobal);
  // console.log('permissionObjGlobal', permissionObjGlobal);
  // console.log('从localStorage中获取用户信息', window.localStorage.getItem('user_info_new'))

  const zonstUserId = userInfoGlobal ? userInfoGlobal.zonst_user_id : 0
  // return
  /* const params = {
    game_id: 0, // 获取所有平台权限
    zonst_id: zonstUserId,
    resource_key: 'wxopappsvr',
  }
  api.authorPermission(params).then((res) => {
    console.log(res)
  }) */
  const data = {
    zonstId: zonstUserId,
    platformKey: 'wxopappsvr',
    groupKey: 'game-common',
  }
  api.getAuthorPermission(data).then((res) => {
    if (res && res.data && +res.data.code === 0) {
      if (!res.data.data.status) return
      const permissionGroupList = res.data.data.permissionGroupList || []
      permissionGroupList.forEach((list) => {
        if (list.groupKey === 'game-common') {
          // permissionObjGlobal = list.permissionKeyList
          // 因为现在新接口直接返回当前拥有哪些游戏权限id数组，所以替换掉之前的存储permission_obj为permission_arr
          window.localStorage.setItem('permission_arr', JSON.stringify(list.permissionKeyList))
          store.commit('saveAuthorPermission', list.permissionKeyList)
        }
      })
    }
  }).catch((err) => {
    console.log('获取用户权限错误!', err);
  })
}

// 获取子游戏
const beforeEnterGameArea = (to, from, next) => {
  store
    .dispatch({
      type: 'getGameAreaList',
      id: to.params.id,
    })
    .then(() => {
      next();
    });
}
// 获取game_id
const beforeEnterGameId = (to, from, callbackFun) => {
  store.commit({
    type: 'getCurrGameId',
    id: to.params.id,
  })
  if (callbackFun) {
    callbackFun();
  }
}

// 生成该用户可以访问的页面数据
export const getUserMenu = () => {}

// 生成路由信息
export const createdRouter = () => {
  // 获取 components 下所有的vue文件
  const contextLazy = require.context('../components', true, /\.vue$/, 'lazy')
  const contextKeys = contextLazy.keys().map((item) => {
    const testData = item.split('.')
    return {
      value: testData[1],
      label: item,
    }
  })
  // 将所有文件转为json形式
  const contextKeysObj = {}
  // 获取菜单信息, 用于生成路由
  const menuData = []

  contextKeys.forEach((contextKeysItem) => {
    const itemArr = contextKeysItem.value.split('/')
    // console.log(itemArr)
    const length = itemArr.length
    const ele = itemArr[length - 1]
    menuData.push(ele)
    contextKeysObj[ele] = {
      path: `${contextKeysItem.value}/:id/`,
      component: contextKeysItem.label,
    }
  })
  console.log(contextKeysObj)

  // 获取需要生成路由的文件
  /* StatesData.statesData.forEach((statesDataItem) => {
    const firstModel = statesDataItem.first_model
    firstModel.forEach((firstModelItem) => {
      if (statesDataItem.index > 0) {
        const nameData = firstModelItem.name.map(mapItem => mapItem.value)
        menuData.push(...nameData)
      }
    })
  }) */

  // 需要获取子游戏的页面
  const needGameArea = StatesData.needGameArea
  // 生成路由
  const routerChildren = []
  menuData.forEach((menuDataItem) => {
    const contextKeysObjOne = contextKeysObj[menuDataItem]
    if (contextKeysObjOne !== undefined) {
      const routerChildrenObj = {
        path: contextKeysObjOne.path,
        name: menuDataItem,
        component: () => contextLazy(contextKeysObjOne.component).default || contextLazy(contextKeysObjOne.component),
      }
      // 给每个页面加上获取game_id的方法
      routerChildrenObj.beforeEnter = function beforeEnter(to, from, next) {
        beforeEnterGameId(to, from, next)
      }
      // 给需要获取子游戏的页面加上获取方法
      const isNeedGameArea = needGameArea.indexOf(menuDataItem)
      if (isNeedGameArea >= 0) {
        routerChildrenObj.beforeEnter = function beforeEnter(to, from, next) {
          beforeEnterGameId(to, from, () => {
            beforeEnterGameArea(to, from, next);
          });
        }
      }
      routerChildren.push(routerChildrenObj)
    }
  })
  return routerChildren
}
